import { createApiSaga } from '../../../sagaGenerator';
import { apiGet } from '../../../../middleware/api';
import {
  GET_MARIGRAM_INFO_REQUEST,
  GET_MARIGRAM_INFO_SUCCESS,
  GET_MARIGRAM_INFO_FAILURE,
  GET_MARIGRAM_INFO_REFERENCES_REQUEST,
  GET_MARIGRAM_INFO_REFERENCES_SUCCESS,
  GET_MARIGRAM_INFO_REFERENCES_FAILURE,
} from './marigramInfoReducer';

const getMarigramInfoSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/marigrams/${action.id}/info`, ...action }),
  requestType: GET_MARIGRAM_INFO_REQUEST,
  successType: GET_MARIGRAM_INFO_SUCCESS,
  failureType: GET_MARIGRAM_INFO_FAILURE,
});

const getMarigramReferencesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/marigrams/${action.id}/references`, ...action }),
  requestType: GET_MARIGRAM_INFO_REFERENCES_REQUEST,
  successType: GET_MARIGRAM_INFO_REFERENCES_SUCCESS,
  failureType: GET_MARIGRAM_INFO_REFERENCES_FAILURE,
});

export const marigramInfoSagas = [
  getMarigramInfoSaga,
  getMarigramReferencesSaga,
];
